import { BaseViewStore } from 'core/stores';
import { makeObservable, observable } from 'mobx';
import _ from 'lodash';

class ErrorWarningInfoModalViewStore extends BaseViewStore {
	@observable errors = null;
	@observable warnings = null;
	@observable info = null;
	@observable title = '';
	@observable subtitleComponent = null;
	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.errors = modalParams.data.errors;
		this.warnings = modalParams.data.warnings;
		this.info = modalParams.data.info;
		this.title = modalParams.data.title;
		this.subtitleComponent = modalParams.data.subtitleComponent;
	}
}

export default ErrorWarningInfoModalViewStore;

